import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class MetafieldsDosis extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateDosis);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateDosis);
  }

  updateDosis = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDosis = event.detail.data.html.querySelector('metafields-dosis');
    if (!newDosis) return;

    this.style.display = newDosis.style.display;
    morph(this, newDosis, { childrenOnly: true });
  };
}

if (!customElements.get('metafields-dosis')) {
  customElements.define('metafields-dosis', MetafieldsDosis);
}
